import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Question } from '@models/dynamic-forms/question';
import { maskedDateValidator } from '@validators/masked-date-validator';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-date-input',
  imports: [ReactiveFormsModule, NgxMaskDirective],
  templateUrl: './date-input.component.html',
  styleUrl: './date-input.component.scss',
})
export class DateInputComponent implements OnInit {
  @Input() public form: FormGroup;
  @Input() public question: Question;

  public ngOnInit() {
    this.addMaskedDateValidator();
  }

  /**
   * Adds a masked date validator to the form control.
   * This ensures that the date input adheres to a specific format and is a valid date.
   */
  private addMaskedDateValidator() {
    this.form.get(this.question.id).addValidators(maskedDateValidator());
  }
}
